<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl']
        ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("settings") }}
      </h1>
    </div>

    <!-- Settings Form Section -->
    <div class="px-6 py-4">
      <div class="">
        <form @submit="updateSettings">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
          <BaseInput
            type="number"
            v-model="set_expire_day_reminder"
            :label="
              $t(
                'how_much_date_before_expire_date_you_want_to_get_notification'
              )
            "
            :placeholder="
              $t(
                'how_much_date_before_expire_date_you_want_to_get_notification'
              )
            "
            :rules="rules"
            :isError="checkRulesIsError(set_expire_day_reminder, 'add').isError"
            :errorMsg="
              checkRulesIsError(set_expire_day_reminder, 'add').errorMsg
            "
          />
          <BaseInput
            type="number"
            v-model="set_item_less"
            :label="
              $t(
                'how_much_item_quantity_before_shortage_you_want_to_get_notification'
              )
            "
            :placeholder="
              $t(
                'how_much_item_quantity_before_shortage_you_want_to_get_notification'
              )
            "
            :rules="rules"
            :isError="checkRulesIsError(set_item_less, 'add').isError"
            :errorMsg="checkRulesIsError(set_item_less, 'add').errorMsg"
          />
          <BaseInput
            type="text"
            v-model="app_name"
            :label="$t('shop_name')"
            :placeholder="$t('shop_name')"
            :rules="rules"
            :isError="checkRulesIsError(app_name, 'add').isError"
            :errorMsg="checkRulesIsError(app_name, 'add').errorMsg"
          />
          <BaseInput
            type="number"
            v-model="set_phone_number"
            :label="$t('phone_number_on_invoices')"
            :placeholder="$t('phone_number_on_invoices')"
            :rules="rules"
            :isError="checkRulesIsError(set_phone_number, 'add').isError"
            :errorMsg="checkRulesIsError(set_phone_number, 'add').errorMsg"
          />
          <BaseInput
            type="number"
            v-model="set_phone_number2"
            :label="$t('phone_number_on_invoices') + ' 2'"
            :placeholder="$t('phone_number_on_invoices') + ' 2'"
            :rules="no_rule"
            :isError="checkRulesIsError(set_phone_number2, 'add', this.no_rule).isError"
            :errorMsg="checkRulesIsError(set_phone_number2, 'add', this.no_rule).errorMsg"
          />
          <BaseInput
            type="text"
            v-model="set_header_invoice"
            :label="$t('header_text_on_invoices')"
            :placeholder="$t('header_text_on_invoices')"
            :rules="no_rule"
            :isError="checkRulesIsError(set_header_invoice, 'add', this.no_rule).isError"
            :errorMsg="checkRulesIsError(set_header_invoice, 'add', this.no_rule).errorMsg"
          />
          <BaseInput
            type="text"
            v-model="set_header_purchase"
            :label="$t('header_text_on_purchases')"
            :placeholder="$t('header_text_on_purchases')"
            :rules="no_rule"
            :isError="checkRulesIsError(set_header_purchase, 'add', this.no_rule).isError"
            :errorMsg="checkRulesIsError(set_header_purchase, 'add', this.no_rule).errorMsg"
          />
          <BaseInput
            type="text"
            v-model="set_header_return_purchase"
            :label="$t('header_text_on_returned_purchases')"
            :placeholder="$t('header_text_on_returned_purchases')"
            :rules="no_rule"
            :isError="
              checkRulesIsError(set_header_return_purchase, 'add', this.no_rule).isError
            "
            :errorMsg="
              checkRulesIsError(set_header_return_purchase, 'add', this.no_rule).errorMsg
            "
          />
          <BaseInput
            type="text"
            v-model="set_address"
            :label="$t('set_address')"
            :placeholder="$t('set_address')"
            :rules="no_rule"
            :isError="checkRulesIsError(set_address, 'add', this.no_rule).isError"
            :errorMsg="checkRulesIsError(set_address, 'add', this.no_rule).errorMsg"
          />
          <TextAreaInput
            v-model="set_description"
            :label="$t('shop_description')"
            :placeholder="$t('shop_description')"
            :rules="no_rule"
            :isError="
              checkRulesIsError(set_description, 'add', this.no_rule).isError
            "
            :errorMsg="
              checkRulesIsError(set_description, 'add', this.no_rule).errorMsg
            "
          />
          <BaseInput
            type="text"
            v-model="set_facebook"
            :label="$t('set_facebook')"
            :placeholder="$t('set_facebook')"
            :rules="no_rule"
            :isError="checkRulesIsError(set_facebook, 'add', this.no_rule).isError"
            :errorMsg="checkRulesIsError(set_facebook, 'add', this.no_rule).errorMsg"
          />
          <BaseInput
            type="text"
            v-model="set_instagram"
            :label="$t('set_instagram')"
            :placeholder="$t('set_instagram')"
            :rules="no_rule"
            :isError="checkRulesIsError(set_instagram, 'add', this.no_rule).isError"
            :errorMsg="checkRulesIsError(set_instagram, 'add', this.no_rule).errorMsg"
          />
          <BaseInput
            type="text"
            v-model="set_tiktok"
            :label="$t('set_tiktok')"
            :placeholder="$t('set_tiktok')"
            :rules="no_rule"
            :isError="checkRulesIsError(set_tiktok, 'add', this.no_rule).isError"
            :errorMsg="checkRulesIsError(set_tiktok, 'add', this.no_rule).errorMsg"
          /><DropdownInput
            v-model="set_price_type_shop"
            :label="$t('shop_state')"
            :items="convertToListIdValuePriceType"
            :placeholder="$t('choose_shop_state')"
            :rules="rules_dropdown"
            :isError="
              checkRulesIsError(set_price_type_shop, 'add', this.rules_dropdown)
                .isError
            "
            :errorMsg="
              checkRulesIsError(set_price_type_shop, 'add', this.rules_dropdown)
                .errorMsg
            "
          />
          <DropdownInput
            v-model="set_is_show_stock_number"
            :label="$t('show_stock_numbers')"
            :items="convertToListIdValueStockNumbers"
            :placeholder="$t('show_stock_numbers')"
            :rules="rules_dropdown"
            :isError="
              checkRulesIsError(
                set_is_show_stock_number,
                'add',
                this.rules_dropdown
              ).isError
            "
            :errorMsg="
              checkRulesIsError(
                set_is_show_stock_number,
                'add',
                this.rules_dropdown
              ).errorMsg
            "
          />
          <FileInput
            v-model="set_logo"
            :label="$t('logo_on_invoices')"
            :placeholder="$t('logo_on_invoices')"
            accept="image/*"
            :show-preview="true"
            @change="onChange"
          />
          <br />
          <div class="flex justify-center">
            <img
              v-if="saved_logo"
              :src="file_url + saved_logo"
              class="w-40 h-40 rounded-full"
            />
          </div>
          <br />
          </div>

          <ButtonInput
            type="button"
            @click="updateSettings"
            :label="$t('edit')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
  <ResultDialog ref="ResultDialog"></ResultDialog>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import ConfirmDialogue from "../../components/Modals/ConfirmDialogue.vue";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import { FILE_URL } from "../../constants/config";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";
import "../../assets/css/modern-table.css";

export default {
  name: "CHANGE_PASSWRD",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ConfirmDialogue,
    ResultDialog,
    TextAreaInput,
    DropdownInput,
    FileInput,
  },
  data() {
    return {
      firstName: "",
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      no_rule: [],
      set_expire_day_reminder: "",
      set_item_less: "",
      inputType: "text",
      isSubmited: false,
      isSubmitedEdit: false,
      current: {},
      set_phone_number: "",
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      set_header_invoice: "",
      set_header_purchase: "",
      set_header_return_purchase: "",
      set_logo: "",
      saved_logo: "",
      app_name: "",

      set_price_type_shop: "0",
      set_is_show_stock_number: "0",
      set_phone_number2: "",
      set_description: "",
      set_address: "",
      set_facebook: "",
      set_instagram: "",
      set_tiktok: "",

      file_url: FILE_URL,
    };
  },

  created() {
    this.getSettings();
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    getResultDialog(newValue, oldValue) {
      if (newValue) {
        this.$refs.ResultDialog.show({
          message: this.$store.state.settings.resultMsg,
          okButton: this.$t("done"),
          isSuccess: this.$store.state.settings.isSuccess,
        });

        // Reset the deleteSuccess state after showing the dialog
        this.$store.commit("settings/SET_DELETE_SUCCESS", false);
      }
    },
  },

  computed: {
    convertToListIdValuePriceType() {
      var list = [
        {
          id: "0",
          value: this.$t("turn_off"),
        },
        {
          id: "1",
          value: this.$t("sale_tak"),
        },
        {
          id: "2",
          value: this.$t("sale_jwmla"),
        },
      ];

      return list;
    },
    convertToListIdValueStockNumbers() {
      var list = [
        {
          id: "0",
          value: this.$t("hide"),
        },
        {
          id: "1",
          value: this.$t("show"),
        },
      ];

      return list;
    },
    getResultDialog() {
      return this.$store.state.settings.isShowResultDialog;
    },
    currentSetting() {
      return this.$store.state.settings.settings;
    },

    isDark() {
      return this.$store.state.theme == "dark";
    },
    isRtl() {
      return (
        localStorage.getItem("lang_wise_manager") == "ar" ||
        localStorage.getItem("lang_wise_manager") == "ku" ||
        //if null
        localStorage.getItem("lang_wise_manager") == null ||
        //if empty
        localStorage.getItem("lang_wise_manager") == ""
      );
    },
    isBtnLoading() {
      return this.$store.state.settings.isBtnLoading;
    },
  },

  methods: {
    onChange(files) {
      this.set_logo = files[0] || null;
    },
    async getSettings() {
      await this.$store.dispatch("settings/getSettings", {});

      this.set_expire_day_reminder =
        this.currentSetting.set_expire_day_reminder;
      this.set_item_less = this.currentSetting.set_item_less;
      this.app_name = this.currentSetting.app_name;
      //set_price_type_shop
      this.set_price_type_shop = this.currentSetting.set_price_type_shop;
      this.set_is_show_stock_number =
        this.currentSetting.set_is_show_stock_number;
      this.set_phone_number2 = this.currentSetting.set_phone_number2;
      this.set_description = this.currentSetting.set_description;
      this.set_address = this.currentSetting.set_address;
      this.set_facebook = this.currentSetting.set_facebook;
      this.set_instagram = this.currentSetting.set_instagram;
      this.set_tiktok = this.currentSetting.set_tiktok;
      this.set_phone_number = this.currentSetting.set_phone_number;
      this.set_header_invoice = this.currentSetting.set_header_invoice;
      this.set_header_purchase = this.currentSetting.set_header_purchase;
      this.set_header_return_purchase =
        this.currentSetting.set_header_return_purchase;
      this.saved_logo = this.currentSetting.set_logo;

      localStorage.setItem(
        "currentSettingWiseManager",
        JSON.stringify(this.currentSetting)
      );
    },
    async updateSettings(e) {
      e.preventDefault();
      //check form validation
      if (this.$store.state.settings.isBtnLoading) return;

      this.isSubmited = true;
      if (
        (this.checkRulesIsError(this.set_item_less, "add").isError,
        this.checkRulesIsError(this.set_expire_day_reminder, "add").isError)
      ) {
        return;
      }

      this.$store.state.settings.isBtnLoading = true;
      var res = await this.$store.dispatch("settings/updateSettings", {
        set_expire_day_reminder: this.set_expire_day_reminder,
        set_item_less: this.set_item_less,
        set_id: this.currentSetting.set_id,
        app_name: this.app_name,
        set_price_type_shop: this.set_price_type_shop,
        set_is_show_stock_number: this.set_is_show_stock_number,
        set_phone_number2: this.set_phone_number2,
        set_description: this.set_description,
        set_address: this.set_address,
        set_facebook: this.set_facebook,
        set_instagram: this.set_instagram,
        set_tiktok: this.set_tiktok,
        set_phone_number: this.set_phone_number,
        set_header_invoice: this.set_header_invoice,
        set_header_purchase: this.set_header_purchase,
        set_header_return_purchase: this.set_header_return_purchase,
        set_logo: this.set_logo,
      });
      if (res.status == 200) {
        this.isSubmited = false;
        this.getSettings();
      }
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      if (type == "edit") {
        if (this.isSubmitedEdit == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }

      // Use provided rules or default to this.rules
      const rulesToUse = rules || this.rules;

      for (const rule of rulesToUse) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
  },
};
</script>
